<template>
  <marketing-automation-form-panel-section :title="$t('message.automation.message.setSpots')">
    <filter-local-tree class="marketing-automation-form-panel-entry-section-local"
                       :value="value"
                       :automationId="automationId"
                       :step="step"
                       @opened="emitOpened"
                       @hidden="emitHidden"
                       @input="$emit('input', $event)" />
  </marketing-automation-form-panel-section>
</template>

<script>
import FilterLocalTree from "@/components/filters/local/tree/FilterLocalTree";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";

export default {
  components: {
    MarketingAutomationFormPanelSection,
    FilterLocalTree,
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  computed: {},

  data() {
    return {};
  },

  methods: {
    emitOpened() {
      this.$emit("opened");
    },
    emitHidden() {
      this.$emit("hidden");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
